<template>
  <el-cascader
    v-model="id"
    :disabled="disabled"
    ref="cascader"
    :show-all-levels="false"
    :options="orgList"
    :props="cascaderProps"
    @change="changeOrg"
  ></el-cascader>
</template>
<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          console.log('get----', newVal)
          this.id = newVal;

        } else {
          this.id = '';
        }
      },
      immediate: true
    }
  },
  // computed: {
  //   currentValue: {
  //     get: function () {
  //       console.log('get----', this.value)
  //       return this.value;
  //     },
  //     set: function (val) {
  //       console.log('set----', val)
  //       this.$emit('input', val);
  //     }
  //   }
  // },
  data() {
    return {
      id: '',
      orgList: [],
      cascaderProps: {
        emitPath: false,
        checkStrictly: true,
      },
      orgMap: {}
    };
  },
  created() {
    this.getOrgList()
  },
  methods: {
    changeOrg(val) {
      console.log('???', val)
      if (!val) return
      this.$emit('input', val);
      this.$emit('change', this.orgMap[val])
    },
    setTreeData(arr) {
      return arr.map((item) => {
        this.orgMap[item.deptId] = item;
        return {
          ...item,
          label: item.deptmantName,
          value: item.deptId,
          children:
            item.children && item.children.length > 0
              ? this.setTreeData(item.children)
              : null,
        }
      }
      )
    },
    refreshValue() {
      if (this.id) {
        this.$refs.cascader.checkedValue = this.id;
        (this.$refs.cascader.$refs.panel.checkedNodePaths || []).forEach(item => {
          this.$set(item[item.length - 1], 'checked', true);
        });
        this.$refs.cascader.computePresentContent();
        this.$forceUpdate();
      }
    },
    getOrgList() {
      this.$http({
        url: '/master/subAccount/getMechanTree',
        type: 'PUT',
        params: this.params,
      }).then((res) => {
        this.orgList = this.setTreeData([res.data])
        // 刷新数据
        // this.refreshValue()
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.el-cascader {
  line-height: inherit;
}
</style>
